<template>
  <EmailCollector
    v-bind="{ ...translationProps }"
    :source
    :tracking
    @submitted="handleSubmit"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { EmailSource } from '@backmarket/nuxt-layer-cms/EmailCollector.types'
import EmailCollector from '@backmarket/nuxt-layer-cms/EmailCollector.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './EmailCollector.translations'

defineProps<{ source: EmailSource }>()

const i18n = useI18n()

const emit = defineEmits(['actioned'])

const hasTerms = computed(() => {
  return (
    !!i18n(translations.emailCollectorPopupTermsTitle) &&
    !!i18n(translations.emailCollectorPopupTermsDescription)
  )
})

const tracking = {
  name: 'email_sign_up',
  zone: 'email_collection_notification',
}

const translationProps = {
  title: i18n(translations.emailCollectorPopupTitle),
  text: i18n(translations.emailCollectorPopupDescription),
  buttonLabel: i18n(translations.emailCollectorPopupFormButton),
  placeholderLabel: i18n(translations.emailCollectorPopupFormPlaceholder),
  legalText: i18n(translations.emailCollectorPopupLegalText),
  legalLinkText: i18n(translations.emailCollectorPopupLinkPolicy),
  emailCollectorTerms: {
    title: i18n(translations.emailCollectorPopupTermsTitle),
    text: i18n(translations.emailCollectorPopupTermsDescription),
    hide: !hasTerms.value,
  },
  toastText: {
    successTitle: i18n(translations.toastSuccessTitle),
    successMessage: i18n(translations.toastSuccessMessage),
  },
}

function handleSubmit() {
  emit('actioned')
}
</script>
